module.exports = __webpack_public_path__ + "static/media/gameEnding_2.20856b32.mp3";